import React, { useState } from 'react';
import { useNavigate, Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Eye, EyeOff } from 'lucide-react';
import logoImg from '../assets/logo.png';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { useToast } from '../hooks/use-toast';

const Login = () => {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const { toast } = useToast();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/dashboard" replace />;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const result = await login(username, password);
    if (result.success) {
      toast({ title: 'Login berhasil', description: 'Selamat datang di BP3' });
      navigate('/dashboard');
    } else {
      toast({ title: 'Login gagal', description: result.message, variant: 'destructive' });
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-gray-50">
      <div className="w-full max-w-md">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-12 h-12 flex items-center justify-center flex-shrink-0">
            <img src={logoImg} alt="BP3 Logo" className="w-12 h-12 object-contain" />
          </div>
          <div>
            <h1 className="text-2xl font-extrabold">BP3</h1>
            <p className="text-[10px] font-semibold tracking-[0.15em] opacity-70">PKS KAB. SUKABUMI</p>
          </div>
        </div>

        <h2 className="text-3xl font-extrabold text-gray-900">Selamat Datang!</h2>
        <p className="text-gray-500 font-medium mt-2 mb-8">Masuk ke sistem pemenangan Anda</p>

        <form onSubmit={handleSubmit} className="space-y-5">
          <div>
            <Label className="font-semibold text-gray-700 text-sm mb-2 block">Username</Label>
            <Input
              value={username}
              onChange={e => setUsername(e.target.value)}
              placeholder="Masukkan username"
              className="h-12 rounded-xl border-gray-200 font-medium"
              autoComplete="username"
              required
            />
          </div>
          <div>
            <Label className="font-semibold text-gray-700 text-sm mb-2 block">Password</Label>
            <div className="relative">
              <Input
                type={show ? 'text' : 'password'}
                value={password}
                onChange={e => setPassword(e.target.value)}
                placeholder="Masukkan password"
                className="h-12 rounded-xl border-gray-200 font-medium pr-11"
                autoComplete="current-password"
                required
              />
              <button type="button" onClick={() => setShow(!show)} className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600">
                {show ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
              </button>
            </div>
          </div>

          <Button type="submit" disabled={loading} className="w-full h-12 rounded-xl bg-orange-500 hover:bg-orange-600 text-white font-bold text-base shadow-lg shadow-orange-500/30">
            {loading ? 'Memproses...' : 'Masuk ke Dashboard'}
          </Button>
        </form>
      </div>
    </div>
  );
};

export default Login;
